import { composeFetch, createFetch, defaultFetchConfig } from '@cbhq/data-layer';
import { apiCamelizeMiddleware } from '@cbhq/instant-api-hooks-core/fetch';

import { oauthRedirect, SHOULD_NOT_REDIRECT } from '../auth/authHelpers';
import { targetEnvironment } from '../configs/environments';
import { SELECTED_ORG_KEY } from '../contexts/OrganizationProvider';

import { tracing } from './tracing';

const authRedirectingFetch = composeFetch(
  [tracing],
  createFetch({
    ...defaultFetchConfig,
    credentials: 'include',
    retryRateLimit: false,
    disableAnalyticsHeaders: targetEnvironment === 'local',
    retryUnauthorized: {
      handleUnauthorized: async () => {
        if (SHOULD_NOT_REDIRECT.includes(window.location.pathname)) {
          return false;
        }

        try {
          localStorage.removeItem(SELECTED_ORG_KEY);
        } catch {
          // localStorage may be unavailable; proceed with redirect regardless
        }

        oauthRedirect();

        await new Promise((resolve) => {
          setTimeout(resolve, 10000);
        });

        return false;
      },
    },
  }),
);

export const apiFetch = composeFetch([apiCamelizeMiddleware], authRedirectingFetch);
